import React, { useEffect, useState } from 'react';
import './App.css';
import SubscNaviHome from './components/SubscNaviHome';
import AuthPage from './components/AuthPage';
import LandingPage from './components/LandingPage';
import { useAuth } from './hooks/useAuth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// QueryClientの作成
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 60 * 5, // 5分
    },
  },
});

function App() {
  const { user, logout, initialize, isAuthenticated } = useAuth();
  const [showLanding, setShowLanding] = useState(true);

  // アプリ初期化時にトークンがあれば自動ログイン試行
  useEffect(() => {
    initialize().then(() => {
      // 既にログイン済みの場合はランディングページをスキップ
      if (isAuthenticated()) {
        setShowLanding(false);
      }
    });
  }, [initialize, isAuthenticated]);

  const handleLogout = () => {
    logout();
    setShowLanding(true); // ログアウト時はランディングページに戻る
  };

  const handleGetStarted = () => {
    setShowLanding(false); // 認証ページに移動
  };

  const handleBackToLanding = () => {
    setShowLanding(true); // ランディングページに戻る
  };

  const handleLoginSuccess = () => {
    setShowLanding(false); // ログイン成功時もランディングページを非表示
  };

  return (
    <QueryClientProvider client={queryClient}>
      <div>
        {/* 認証済みユーザー用の操作ボタン */}
        {user && !showLanding && (
          <div className="fixed top-4 right-4 z-50 flex items-center gap-2">
            <span className="text-sm text-gray-600">
              {user.name || user.email}
            </span>
            <button
              onClick={handleLogout}
              className="bg-gray-800 text-white px-4 py-2 rounded-lg text-sm hover:bg-gray-700 transition-colors"
            >
              ログアウト
            </button>
          </div>
        )}

        {/* 画面の切り替え */}
        {showLanding ? (
          <LandingPage onGetStarted={handleGetStarted} />
        ) : isAuthenticated() ? (
          <SubscNaviHome />
        ) : (
          <AuthPage 
            onAuthSuccess={handleLoginSuccess} 
            onBack={handleBackToLanding}
          />
        )}
      </div>
    </QueryClientProvider>
  );
}

export default App;
